import { xFindClosestIndex } from './xFindClosestIndex';
/**
 *  Returns the targetIndex
 *
 * @param x - array of numbers
 * @param options - options
 */
export function xGetTargetIndex(x, options = {}) {
    let { target, targetIndex } = options;
    if (targetIndex === undefined) {
        if (target !== undefined) {
            return xFindClosestIndex(x, target);
        }
        else {
            return 0;
        }
    }
    return targetIndex;
}
//# sourceMappingURL=xGetTargetIndex.js.map